export * from "../../original/js/components/charts";
import { Charts } from "../../original/js/components/charts";

export default Charts;
